module.exports = __webpack_public_path__ + "img/parthner-1.811e7812.svg";